import React, { useState } from "react";
import OffCanvasButton from "./OffCanvasButton";
import FilterOffCanvas from "./OffCanvasBody";
import FilterTitle from "./filter/FilterTitle";
import UploadBox from "./UploadBox";
import FilterSearch from "./filter/Location/FilterSearch";
import SelectFilter from "./filter/SelectFilter";
import FilterTextarea from "./filter/FilterTextArea";
import FilterCheckboxGroup from "./filter/FilterCheckBoxGroup";
import lenguageData from "../../data/HealthCenterInfo/lenguages.json";
import insuranceData from "../../data/HealthCenterInfo/insurances.json";
import paymentData from "../../data/HealthCenterInfo/payments.json";
import validationData from "../../data/HealthCenterInfo/validation.json";
import singLenguageData from "../../data/HealthCenterInfo/singLenguage.json";
import accesibilitiesData from "../../data/HealthCenterInfo/otherAccessibilities.json";
import FileUploadBox from "./filter/FileUploadBox";
import RatingFilter from "./filter/RatingFilter";
import { createHealthCenter } from "../../pages/DoctorManagement/HealthCenters/HealthCenterServices";

const LargeOffCanvasButton = ({ label, icon, onCenterCreated }) => {
    const [formData, setFormData] = useState({
        name: "",
        type: "",
        phone: "",
        email: "",
        website: "",
        address: "",
        services: [],
        departments: [],
        facilities: [],
        equipments: [],
        languages: [],
        paymentMethod: [],
        insurance: [],
        hasParking: null,
        wheelChairAccess: null,
        medicaid: true,
        specialties: [],
        hours: [],
        accessibility: [],
        rating: null,
        cif: "",
        city: "",
        state: "",
        zipcode: "",
        about: "",
        image: null,
        uploads: [],
        signLanguageSupport: "",
    });

    const handleClear = () => {
        setFormData({
            name: "",
            type: "",
            phone: "",
            email: "",
            website: "",
            address: "",
            services: [],
            departments: [],
            facilities: [],
            equipments: [],
            languages: [],
            paymentMethod: [],
            insurance: [],
            hasParking: null,
            wheelChairAccess: null,
            medicaid: true,
            specialties: [],
            hours: [],
            accessibility: [],
            rating: null,
            cif: "",
            city: "",
            state: "",
            zipcode: "",
            about: "",
            image: null,
            uploads: [],
        });
    };

    console.log("formData:", formData);

    const handleSave = async () => {
        const requiredFields = [
            "name", "type", "phone", "email", "website", "address",
            "services", "departments", "facilities", "equipments",
            "languages", "paymentMethod", "insurance", "cif",
            "city", "state", "zipcode", "about"
        ];

        const missingFields = requiredFields.filter((field) => {
            if (Array.isArray(formData[field])) {
                return formData[field].length === 0;
            }
            return !formData[field];
        });

        if (missingFields.length > 0) {
            const errorMessage = `Please fill in the following required fields: ${missingFields.join(", ")}`;
            alert(errorMessage);
            return;
        }

        try {
            // Clonar facilities e insertar soporte de lenguaje de señas como texto
            const updatedFacilities = [...formData.facilities];
            if (formData.signLanguageSupport) {
                updatedFacilities.push(`Sign Language Support: ${formData.signLanguageSupport}`);
            }

            const dataToSend = {
                ...formData,
                facilities: updatedFacilities,
            };

            // Eliminar campo que no está en el schema
            delete dataToSend.signLanguageSupport;

            const result = await createHealthCenter(dataToSend);
            console.log("Health center created:", result);

            alert("✅ Se ha añadido correctamente");

            if (typeof onCenterCreated === "function") {
                onCenterCreated();
            }

            const closeBtn = document.querySelector('[data-bs-dismiss="offcanvas"]');
            if (closeBtn) closeBtn.click();

            handleClear();
        } catch (error) {
            console.error("Error creating center:", error);
            alert("❌ Error al añadir el centro");
        }
    };


    return (
        <>
            
            <button
                            type="button"
                            className="btn btn-primary addnewbtn"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#segundoOffCanvas"
                            aria-controls="segundoOffCanvas"
                            onClick={handleClear}
                        >
                            + Add New
                        </button>

            <FilterOffCanvas
                id="segundoOffCanvas"
                title="Add Health Center"
                width="offcanvas-wide"
                leftButton="Close"
                rightButton="Save"
                onApply={handleSave}
                onClear={handleClear}
            >
                <FilterTitle title="Basic Information" />
                <div className="row g-3 align-items-start mb-4">
                    <div className="col-auto">
                        <UploadBox padding="p-5" label="Profile Picture" subtext="Max 20mb pdf" />
                    </div>
                    <div className="col">
                        <div className="row g-2">
                            <div className="col-12">
                                <FilterSearch
                                    label="Name"
                                    placeholder="Enter center name"
                                    widthClass="w-100"
                                    pbInput="p-4 py-3"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                />
                            </div>
                            <div className="col-md-6">
                                <SelectFilter
                                    label="Type"
                                    options={["Select type of the centre", "Hospital", "Clinic"]}
                                    pInput="p-4 py-3"
                                    value={formData.type}
                                    onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                />
                            </div>
                            <div className="col-md-6">
                                <FilterSearch
                                    label="Phone No."
                                    placeholder="Enter phone number"
                                    widthClass="w-100"
                                    pbInput="p-4 py-3"
                                    value={formData.phone}
                                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <FilterSearch
                                    label="Email"
                                    placeholder="Enter your email"
                                    pbInput="p-4 py-3"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                />
                            </div>
                            <div className="col-md-6">
                                <FilterSearch
                                    label="Website URL"
                                    placeholder="Enter website url"
                                    pbInput="p-4 py-3"
                                    value={formData.website}
                                    onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <FilterSearch
                                    label="City"
                                    placeholder="Enter city"
                                    pbInput="p-4 py-3"
                                    value={formData.city}
                                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                />
                            </div>
                            <div className="col-md-6">
                                <FilterSearch
                                    label="State"
                                    placeholder="Enter state"
                                    pbInput="p-4 py-3"
                                    value={formData.state}
                                    onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <FilterSearch
                                    label="CIF"
                                    placeholder="Enter CIF code"
                                    pbInput="p-4 py-3"
                                    value={formData.cif}
                                    onChange={(e) => setFormData({ ...formData, cif: e.target.value })}
                                />
                            </div>
                            <div className="col-md-6">
                                <FilterSearch
                                    label="Zip code"
                                    placeholder="Enter zip code"
                                    pbInput="p-4 py-3"
                                    value={formData.zipcode}
                                    onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <FilterSearch
                            label="Address"
                            placeholder="Enter your address"
                            pbInput="p-4 py-3"
                            value={formData.address}
                            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                        />
                    </div>
                </div>

                {/* Advanced Information */}
                <FilterTitle title="Advanced Information" />
                <div className="mb3">
                    <FilterTextarea
                        label="Services Offered"
                        id="services"
                        placeholder="Enter list of medical services offered"
                        pbInput="pb-2"
                        value={formData.services}
                        onChange={(e) => setFormData({ ...formData, services: e.target.value.split(",") })}
                    />
                    <FilterTextarea
                        label="Departments"
                        placeholder="Enter departments available"
                        as="textarea"
                        widthClass="w-100"
                        value={formData.departments}
                        onChange={(e) => setFormData({ ...formData, departments: e.target.value.split(",") })}
                    />
                    <FilterTextarea
                        label="Facilities"
                        placeholder="Enter list of available facilities"
                        as="textarea"
                        widthClass="w-100"
                        value={formData.facilities}
                        onChange={(e) => setFormData({ ...formData, facilities: e.target.value.split(",") })}
                    />
                    <FilterTextarea
                        label="Equipment"
                        placeholder="Enter list of specialized medical equipment"
                        as="textarea"
                        widthClass="w-100"
                        value={formData.equipments}
                        onChange={(e) => setFormData({ ...formData, equipments: e.target.value.split(",") })}
                    />

                    <FilterTextarea
                        label="About the Center"
                        placeholder="Describe this health center..."
                        value={formData.about}
                        onChange={(e) => setFormData({ ...formData, about: e.target.value })}
                    />
                </div>

                <FilterTitle title="Operational Information" />
                <div className="g-4">
                    <FilterCheckboxGroup
                        title="Languages Spoken"
                        data={lenguageData.languages}
                        selectedItems={formData.languages}
                        setSelectedItems={(items) => setFormData({ ...formData, languages: items })}
                    />
                    <FilterCheckboxGroup
                        title="Payment Options"
                        data={paymentData.payments}
                        selectedItems={formData.paymentMethod}
                        setSelectedItems={(items) => setFormData({ ...formData, paymentMethod: items })}
                    />
                    <FilterCheckboxGroup
                        title="Insurance Accepted"
                        data={insuranceData.insurances}
                        selectedItems={formData.insurance}
                        setSelectedItems={(items) => setFormData({ ...formData, insurance: items })}
                    />
                </div>

                <FilterTitle title="Accessibility Information" />
                <div className="mt-4 g-4">
                    <FilterCheckboxGroup
                        title="Wheelchair Accessible"
                        data={validationData.yesNoOptions}
                        type="radio"
                        selectedItems={[
                            formData.wheelChairAccess === true
                                ? "Yes"
                                : formData.wheelChairAccess === false
                                    ? "No"
                                    : ""
                        ]}
                        setSelectedItems={(items) => {
                            const val = items[0];
                            setFormData({
                                ...formData,
                                wheelChairAccess:
                                    val === "Yes" ? true : val === "No" ? false : null
                            });
                        }}
                    />
                    <FilterCheckboxGroup
                        title="Parking Accessible"
                        data={validationData.yesNoOptions}
                        type="radio"
                        selectedItems={[
                            formData.hasParking === true
                                ? "Yes"
                                : formData.hasParking === false
                                    ? "No"
                                    : ""
                        ]}
                        setSelectedItems={(items) => {
                            const val = items[0];
                            setFormData({
                                ...formData,
                                hasParking:
                                    val === "Yes" ? true : val === "No" ? false : null
                            });
                        }}
                    />


                    <FilterCheckboxGroup
                        title="Sign Language Interpreter"
                        data={singLenguageData.availabilityOptions}
                        type="radio"
                        selectedItems={[formData.signLanguageSupport]}
                        setSelectedItems={(items) => setFormData({ ...formData, signLanguageSupport: items[0] })}
                    />

                    <FilterCheckboxGroup
                        title="Other Accessibility Features"
                        data={accesibilitiesData.accessibilityFeatures}
                        selectedItems={formData.accessibility}
                        setSelectedItems={(items) => setFormData({ ...formData, accessibility: items })}
                    />
                </div>

                <FilterTitle title="Quality and Accreditation" />
                <div className="mt-4 g-4">
                    <FileUploadBox title="Certificates" />
                    <FileUploadBox title="Awards And Recognition" />
                    <FileUploadBox title="Quality Metrics" />

                    <RatingFilter
                        title="Center Rating"
                        value={formData.rating ?? null}
                        onChange={(rating) => setFormData({ ...formData, rating })}
                    />
                </div>
            </FilterOffCanvas>
        </>
    );
};

export default LargeOffCanvasButton;
